<script setup>
import BrandButton from '@/components/ui/BrandButton.vue'
</script>

<template>
    <section
        class="bg-white pt-32 pb-20 md:pt-40 md:pb-28"
        id="top"
    >
        <div class="mx-auto max-w-7xl px-6 lg:px-10">
            <div class="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
                <div>
                    <h1
                        class="text-brand-900 text-4xl leading-[1.05] font-extrabold tracking-tight sm:text-5xl md:text-6xl lg:text-7xl"
                    >
                        Účetnictví, <br />
                        které dává smysl.
                    </h1>

                    <p class="mt-8 max-w-xl text-lg leading-relaxed text-zinc-600">
                        Pomáháme živnostníkům a malým firmám mít ve financích pořádek a čistou hlavu. Spolupráci stavíme
                        na flexibilitě a lidském přístupu.
                    </p>

                    <div class="mt-10">
                        <BrandButton
                            size="lg"
                            href="#contact"
                        >
                            Chci moderní účetnictví
                        </BrandButton>

                        <p class="text-brand-900/70 mt-3 text-xs font-semibold tracking-[0.18em] uppercase">
                            Online i osobně
                        </p>
                    </div>
                </div>

                <div class="relative">
                    <div
                        class="relative aspect-4/3 w-full overflow-hidden rounded-2xl bg-zinc-100 shadow-lg shadow-zinc-200/50"
                    >
                        <picture>
                            <source
                                srcset="/images/hero-founders.webp"
                                type="image/webp"
                            />

                            <img
                                class="absolute inset-0 h-full w-full object-cover"
                                src="/images/hero-founders.jpg"
                                alt="Zakladatelé SolveCount — Adam Žáček a Ing. Kristýna Zavadilová"
                                fetchpriority="high"
                                width="1200"
                                height="800"
                            />
                        </picture>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
